var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.close),expression:"close"}],staticClass:"navbar-menu-mobile"},_vm._l((_vm.actions),function(action,index){return _c('div',{key:index,staticClass:"navbar-menu-mobile-actions",class:{
      'bg-tahiti-500 text-white': _vm.activeIndex === index,
      'disabled': /*action === 'Relocate IFC' ||*/ action === 'All Tools IFC'
      // action === 'Split IFC'
    },on:{"click":function($event){$event.stopPropagation();return _vm.handleAction(action)}}},[_c('p',{staticClass:"font-semibold",domProps:{"textContent":_vm._s(action)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }